<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Smart Irrigation</a>
      </li>
      <li class="breadcrumb-item">
        <a>Dashboard</a>
      </li>
    </ol>
  </div>    
  <div class="col-lg-2">
    <div class="mb-3 d-flex justify-content-end">
      <button class="btn btn-outline-white btn-sm mr-2" (click)="ngOnInit()" [disabled]="syncing"><i class="fa fa-sync"></i></button>
      <div class="btn-group ml-2">
        <button class="btn btn-outline-white btn-sm" (click)="viewMode = 'table'" [disabled]="viewMode == 'table'"><i class="fa fa-table"></i></button>
        <button class="btn btn-outline-white btn-sm" (click)="viewMode = 'grid'" [disabled]="viewMode == 'grid'"><i class="fa fa-th"></i></button>
      </div>
    </div>
  </div>  
</div>
  
<div class="wrapper wrapper-content animated fadeInRight">
  
  <div class="mb-3" *ngIf="model == null">
    <div class="alert alert-info">
      <i class="fa fa-info-circle"></i> Loading data...
    </div>
  </div>
  <div class="mb-3" *ngIf="model && model.weatherStations && model.weatherStations.length > 0">
    <div class="col-12 mb-3 mt-3">
      <h2 class="h3">Weather Stations</h2>      
    </div>
    <div *ngIf="viewMode == 'table'">
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Station</th>
            <th>Last Seen</th>
            <th class="text-end">Wind (m/s)</th>
            <th class="text-end">Temp (°C)</th>
            <th class="text-end">Humidity (%)</th>
            <th class="text-end">24h Rain (mm)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ws of model.weatherStations">
            <td class="align-middle">
              <div class="fw-bold">{{ ws.description || ws.name || ws.deviceEui }}</div>
              <small class="text-muted d-block">{{ ws.location?.name }}</small>
            </td>
            <td class="align-middle"><small class="text-muted">{{ ws.lastSeen | relativeDate }}</small></td>
            <td class="align-middle text-end">
              {{ ws.currentWindSpeed?.value != null ? (ws.currentWindSpeed.value | number:'1.1-1') : '--' }}m/s
            </td>
            <td class="align-middle text-end">
              {{ ws.currentTemperature?.value != null ? (ws.currentTemperature.value | number:'1.1-1') : '--' }}°C
            </td>
            <td class="align-middle text-end">
              {{ ws.currentHumidity?.value != null ? (ws.currentHumidity.value | number:'1.0-0') : '--' }}%
            </td>
            <td class="align-middle text-end">
              {{ ws.currentRainfall?.value != null ? (ws.currentRainfall.value | number:'1.1-1') : '--' }}mm
            </td>
          </tr>

          <tr *ngIf="model.weatherStations.length == 0">
            <td colspan="7" class="text-center">No weather stations available</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row" *ngIf="viewMode == 'grid'">
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3" *ngFor="let ws of model.weatherStations">
        

        <div class="card card-weather">
          <div class="card-header justify-content-between align-items-center bg-black bg-opacity-20 d-flex  small  text-truncate text-uppercase" >
              <h5 class="card-title mb-2 mt-2 fw-bold">{{ ws.description || ws.name || ws.deviceEui }}</h5>
                <span class="small">
                  {{ws.lastSeen | relativeDate}}
                </span>
          </div>
          <div class="card-body bg-black bg-opacity-10 p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex w-100 justify-content-between align-items-center">
                  <div class="text-center mx-2">
                    <div class="h4 mb-1"><i class="fas fa-wind"></i></div>
                    <div class="fw-bold">
                      {{ ws.currentWindSpeed?.value != null ? (ws.currentWindSpeed.value | number:'1.1-1') : '--' }} m/s
                    </div>
                    <small class="text-muted">Wind</small>
                  </div>

                  <div class="text-center mx-2">
                    <div class="h4 mb-1"><i class="fas fa-thermometer-half"></i></div>
                    <div class="fw-bold">
                      {{ ws.currentTemperature?.value != null ? (ws.currentTemperature.value | number:'1.1-1') : '--' }}°C
                    </div>
                    <small class="text-muted">Temperature</small>
                  </div>

                  <div class="text-center mx-2">
                    <div class="h4 mb-1"><i class="fas fa-tint"></i></div>
                    <div class="fw-bold">
                      {{ ws.currentHumidity?.value != null ? (ws.currentHumidity.value | number:'1.0-0') : '--' }}%
                    </div>
                    <small class="text-muted">Humidity</small>
                  </div>

                  <div class="text-center mx-2">
                    <div class="h4 mb-1"><i class="fas fa-cloud-showers-heavy"></i></div>
                    <div class="fw-bold">
                      {{ ws.currentRainfall?.value != null ? (ws.currentRainfall.value | number:'1.1-1') : '--' }} mm
                    </div>
                    <small class="text-muted">24h Rain</small>
                  </div>
                </div>
              </div>  
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <div class="row" *ngIf="controllers && controllers.length > 0">
    <div class="col-12  mt-3 mb-3">
      <h2 class="h3">Irrigation Controllers</h2>
    </div>
    <div *ngIf="viewMode == 'table'" class="col-12 mb-3">
      
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Controller</th>
            <th class="text-center">Current State</th>
            <th class="text-center">Expected State</th>
            <th class="text-center">Next State</th>
            <th class="text-center">Soil Moisture</th>
            <th>Alarms</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let controller of controllers" [ngClass]="controller.currentState.value ? 'bg-success' : 'bg-danger'" class="bg-opacity-20">
            <td>{{ controller.description || controller.name || controller.deviceEui }}</td>
            <td class="text-center">
              <span class="status-badge badge" (click)="toggleControllerState(controller);toggleControllerModal.show();" style="cursor: pointer;" title="Toggle Controller State">
                  <i class="fas" [ngClass]="controller.currentState.value ? 'fa-toggle-on' : 'fa-toggle-off'" [title]="controller.currentState.value ? 'Irrigation Currently Allowed' : 'Irrigation Currently Disabled'"></i>
                  {{ controller.currentState.value ? 'On' : 'Off' }}
              </span>
            </td>
            <td class="text-center">
              <span class="status-badge badge">
                  <i class="fas" [ngClass]="controller.expectedState.value ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                  {{ controller.expectedState.value ? 'On' : 'Off' }}
              </span>
              <br/>
              <small class="text-muted ">{{controller.expectedState.timeStamp | relativeDate}}</small>
            </td>
            <td class="text-center">
              <span class="status-badge badge">
                  <i class="fas" [ngClass]="controller.nextExpectedState  ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                  {{ controller.nextExpectedState.value ? 'On' : 'Off' }}
              </span>
              <br/>
              <small class="text-muted ">{{controller.nextExpectedState.timeStamp | relativeDate}}</small>
            </td>
            <td class="text-center">
              <div *ngIf="controller.soilMoisturePercentage">
                {{ controller.soilMoisturePercentage?.value != null ? (controller.soilMoisturePercentage.value | number:'1.1-1') : '--' }}%
              </div>
              <div *ngIf="!controller.soilMoisturePercentage">
                N/A
              </div>
            </td>
            <td>
              <div *ngFor="let alarm of controller.alarms">
                <div class="alert alert-danger py-1 mb-1" role="alert" [ngClass]="{'alert-danger':alarm.level == 1,'alert-warning':alarm.level == 2}">
                    <i class="fas fa-exclamation-triangle fa-sm"></i> {{ alarm.message }}
                </div>
              </div>
              <small class="text-muted" *ngIf="controller.alarms.length == 0">No alerts</small>
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-primary mr-2" (click)="toggleControllerState(controller);toggleControllerModal.show();"><i class="fa fa-power-off"></i></button>
              <button class="btn btn-sm btn-primary" (click)="startEditController(controller);controllerModal.show();"><i class="fa fa-edit"></i></button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="row" *ngIf="viewMode == 'grid'">
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3" *ngFor="let controller of controllers">

        <div class="et-card" [ngClass]="'et-card--' + (controller.alarms?.length > 0 ? 'alert' : (!controller.currentState?.value ? 'warning' : 'normal'))">

          <div class="et-card__header">
            <div>
              <div class="et-card__name">{{ controller.description || controller.name || controller.deviceEui }}</div>
              <small class="et-card__lastseen">{{ controller.lastSeen | relativeDate }}</small>
            </div>
            <span class="et-badge" [ngClass]="'et-badge--' + (controller.alarms?.length > 0 ? 'alert' : (!controller.currentState?.value ? 'warning' : 'normal'))">
              {{ controller.currentState?.value ? 'ON' : 'OFF' }}
            </span>
          </div>

          <div class="et-card__body">
            <div class="et-card__row">
              <span class="et-card__label">Current State</span>
              <span class="et-card__value" [class.et-card__value--on]="controller.currentState?.value" [class.et-card__value--off]="!controller.currentState?.value">
                <i class="fas" [ngClass]="controller.currentState?.value ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                {{ controller.currentState?.value ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
            <div class="et-card__row">
              <span class="et-card__label">Expected State</span>
              <span class="et-card__value">
                <i class="fas" [ngClass]="controller.expectedState?.value ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                {{ controller.expectedState?.value ? 'On' : 'Off' }}
                <small class="et-card__ts">{{ controller.expectedState?.timeStamp | relativeDate }}</small>
              </span>
            </div>
            <div class="et-card__row" *ngIf="controller.nextExpectedState">
              <span class="et-card__label">Next State</span>
              <span class="et-card__value">
                <i class="fas" [ngClass]="controller.nextExpectedState?.value ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                {{ controller.nextExpectedState?.value ? 'On' : 'Off' }}
                <small class="et-card__ts">{{ controller.nextExpectedState?.timeStamp | relativeDate }}</small>
              </span>
            </div>
            <div class="et-card__row" *ngIf="controller.soilMoisturePercentage">
              <span class="et-card__label">Soil Moisture</span>
              <span class="et-card__value">{{ controller.soilMoisturePercentage?.value != null ? (controller.soilMoisturePercentage.value | number:'1.1-1') + '%' : '--' }}</span>
            </div>

            <ng-container *ngIf="controller.alarms?.length > 0">
              <div class="et-card__message" [ngClass]="alarm.level <= 1 ? 'et-card__message--error' : 'et-card__message--warning'" *ngFor="let alarm of controller.alarms">
                <i class="fas fa-exclamation-triangle fa-sm me-1"></i>{{ alarm.message }}
              </div>
            </ng-container>
            <small class="et-card__no-alerts" *ngIf="controller.alarms?.length === 0">No alerts</small>
          </div>

          <div class="et-card__footer et-card__footer--actions">
            <button class="btn btn-xs btn-default" (click)="toggleControllerState(controller); toggleControllerModal.show()" title="Toggle controller state">
              <i class="fa fa-power-off"></i> Toggle
            </button>
            <button class="btn btn-xs btn-default" (click)="startEditController(controller); controllerModal.show()" title="Edit controller">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button class="btn btn-xs btn-default" (click)="showStats(controller); statsModal.show()" title="View stats">
              <i class="fas fa-table"></i> Stats
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>  

<div class="modal fade" bsModal #controllerModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" *ngIf="editController">
            <h5 class="modal-title">Edit {{ editController.name || editController.deviceEui }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="controllerModal.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="editController">
          <tabset>
            <!--<tab heading="Automated Schedules">
              <app-automated-schedule-editor
                [schedules]="masterEditSchedules"
                (scheduleChange)="onScheduleChange($event)"
                (scheduleAdd)="onScheduleAdd($event)"
                (scheduleDelete)="onScheduleDelete($event)">
              </app-automated-schedule-editor>
            </tab>-->
            <tab heading="Weather Thresholds">
              <br/>
              <i>Weather Related Thresholds. Uses closes active weather station.</i>
              <br/>
              <small class="form-text text-muted">These can be edited in the DataBus by changing the 'disableMinutes' and 'rainfallThreshold' meta tags.</small>
              <br/>
              <div class="form-group mb-3">
                <label for="rainThreshold">Rainfall Threshold (mm in 24h)</label>
                <input type="number" class="form-control" id="rainThreshold" disabled="true" [(ngModel)]="editController.rainfallThreshold" />
                <small class="form-text text-muted">If rainfall in the last 24 hours exceeds this value, irrigation will be disabled.</small>
              </div>
              <div class="form-group mb-3">
                <label for="rainThreshold">Disabled Window</label>
                <input type="number" class="form-control" id="rainThreshold" disabled="true" [(ngModel)]="editController.defaultDisableTimeMinutes" />
                <small class="form-text text-muted">How long in minutes will irrigation be disabled.</small>
              </div>

            </tab>
            <tab heading="Override Schedules">
              <i>Manual disabling events</i>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Type</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Current</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let s of manualEditSchedules">
                  <td>Manual</td>
                  <td>{{s.startTime | date:'short'}} ({{s.startTime | relativeDate}})</td>
                  <td>{{s.endTime | date:'short'}}  ({{s.endTime | relativeDate}})</td>
                  <td class="text-center"><i *ngIf="s.startTime < minDisableUntil && s.endTime > minDisableUntil" class="fa fa-check"></i></td>
                  <td class="text-center"><button class="btn btn-sm btn-danger mr-2" (click)="deleteManualSchedule(s); $event.stopPropagation()"><i class="fa fa-trash"></i></button></td>
                </tr>
                </tbody>
              </table>
             
            </tab>
            <tab heading="Decision Logs">
<pre>
{{editController.log}}
</pre>
            </tab>
          </tabset>
        </div>
        <div class="modal-footer">           
            <button (click)="controllerModal.hide()" class="btn btn-white">Close</button>
            <button (click)="completeEditController();controllerModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
</div>

<div class="modal fade" bsModal #toggleControllerModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" *ngIf="toggleController">
            <h5 class="modal-title">Toggle {{ toggleController.name || toggleController.deviceEui }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="toggleControllerModal.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="toggleController">
          
              <div class="alert alert-warning">
                <i class="fa fa-exclamation-triangle"></i> 
                Irrigation will be disable for the time specified below. All other schedules will be ignored until the time has passed.
                <br/>
                This will override any other manual settings that are currently active.
              </div>
              <div>
                  Are you sure you want to turn <b>{{ toggleController.currentState.value ? 'Off' : 'On' }}</b> the controller <b>{{ toggleController.name || toggleController.deviceEui }}</b>?
                  <br/>
                  <label for="disableFrom">Disable From:</label>
                  <input type="datetime-local" id="disableFrom" 
                      [ngClass]="{'is-invalid': !isDisableUntilValid, 'is-valid': isDisableUntilValid, 'form-control': true}"    
                      [(ngModel)]="toggleDisableFrom" 
                      [min]="minDisableUntil"
                      [max]="maxDisableUntil"
                      (ngModelChange)="validateDisableFrom()"/>
                  <br/>
                  <label for="disableUntil">Disable Until:</label>
                  <input type="datetime-local" id="disableUntil" 
                      [ngClass]="{'is-invalid': !isDisableUntilValid, 'is-valid': isDisableUntilValid, 'form-control': true}"    
                      [(ngModel)]="toggleDisableUntil" 
                      [min]="minDisableUntil"
                      [max]="maxDisableUntil"
                      (ngModelChange)="validateDisableUntil()"/>
              </div>
            
        </div>
        <div class="modal-footer">           
          <button (click)="toggleControllerModal.hide()" class="btn btn-white">Close</button>
          <button (click)="completeToggleControllerState();toggleControllerModal.hide()" class="btn btn-white" [disabled]="!isDisableUntilValid">Save</button>
        </div>
      </div>
    </div>
</div>


<div class="modal fade" bsModal #statsModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" *ngIf="selectedController">
            <h5 class="modal-title">Statistics {{ selectedController.name || selectedController.deviceEui }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="statsModal.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="selectedController">
          
          <table class="table table-striped table-bordered table-hover">
            <tr>
              <th></th>
              <th>Value</th>
              <th>Time Stamp</th>
              <th>Last Raised</th>
              <th>Last Changed</th>
            </tr>
            <tr>
              <td>Controller Last Reported In:</td>
              <td></td>
              <td>{{ selectedController.lastSeen | relativeDate }}</td>
            </tr>
            <tr>
              <td>Controller Last State Changed:</td>
              <td>{{ selectedController.currentState.value ? 'ON' : 'OFF' }}</td>
              <td>{{ selectedController.currentState.timeStamp | relativeDate }}</td>
              <td>{{ selectedController.currentState.lastRaised | relativeDate }}</td>
              <td>{{ selectedController.currentState.lastChanged | relativeDate }}</td>
            </tr>
            <tr>
              <td>Controller Last Expected State:</td>
              <td>{{ selectedController.expectedState.value ? 'ON' : 'OFF'  }}</td>
              <td>{{ selectedController.expectedState.timeStamp | relativeDate }}</td>
              <td>{{ selectedController.expectedState.lastRaised | relativeDate }}</td>
              <td>{{ selectedController.expectedState.lastChanged | relativeDate }}</td>
            </tr>
            <tr>
              <td>Controller Next Expected State:</td>
              <td>{{ selectedController.nextExpectedState.value ? 'ON' : 'OFF'  }}</td>
              <td>{{ selectedController.nextExpectedState.timeStamp | relativeDate }}</td>
              <td>{{ selectedController.nextExpectedState.lastRaised | relativeDate }}</td>
              <td>{{ selectedController.nextExpectedState.lastChanged | relativeDate }}</td>
            </tr>
            <tr *ngIf="selectedController.soilMoisturePercentage">
              <td>Soil Moisture Percentage:</td>
              <td>{{ selectedController.soilMoisturePercentage.value }} %</td>
              <td>{{ selectedController.soilMoisturePercentage.timeStamp | relativeDate }}</td>
              <td>{{ selectedController.soilMoisturePercentage.lastRaised | relativeDate }}</td>
              <td>{{ selectedController.soilMoisturePercentage.lastChanged | relativeDate }}</td>
            </tr>
            <tr *ngIf="selectedController.rainfallLast24Hours">
              <td>Rainfall Last 24 Hours:</td>
              <td>{{ selectedController.rainfallLast24Hours.value }} mm</td>
              <td>{{ selectedController.rainfallLast24Hours.timeStamp | relativeDate }}</td>
              <td>{{ selectedController.rainfallLast24Hours.lastRaised | relativeDate }}</td>
              <td>{{ selectedController.rainfallLast24Hours.lastChanged | relativeDate }}</td>
            </tr>
            
          </table>
              
        </div>
        <div class="modal-footer">           
          <button (click)="statsModal.hide()" class="btn btn-white">Close</button>
          <button (click)="completeToggleControllerState();statsModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
</div>

